module.exports = __webpack_public_path__ + "static/media/ghd_banner_2.72013866.jpg";